import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  disabledView: {
    pointerEvents: "none",
  },
  featuresForm: {
    minHeight: "80vh",
    "& h4": {
      marginBottom: 24,
    },
    [theme.breakpoints.up("lg")]: {
      padding: "40px 124px",
    },
    [theme.breakpoints.down("lg")]: {
      padding: "40px",
    },
    [theme.breakpoints.down("md")]: {
      padding: 24,
    },
  },
  accordion: {
    boxShadow: "none",
    "&:before": {
      background: "none",
    },
    border: "solid 1px rgb(112 112 112 / 11%)",
    borderRadius: 7,
    marginBottom: 12,
    padding: 0,
    "&.Mui-expanded": {
      "& .MuiAccordionSummary-root": {
        background: "#F8F7F8",
        borderRadius: "7px 7px 0 0",
        color: "#000000",
      },
      "& .MuiAccordionSummary-expandIcon": {
        background: "#EEEDEE",
        border: "solid 1px #D0D0D1",
        "& svg": {
          color: "#858585",
        },
      },
      "&:last-child": {
        marginBottom: 16,
      },
    },
    "& .MuiAccordionSummary-root": {
      padding: "2px 12px",
    },
  },
  heading: {
    fontSize: 14,
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
  },
  successStory: {
    width: "100%",
    border: "solid 2px rgb(112 112 112 / 11%)",
  },
  switchLabel: {
    fontSize: 13,
    fontWeight: 500,
    marginRight: 30,
    display: "block",
  },
  targetWrapper: {
    border: "solid 1px rgb(112 112 112 / 11%)",
    borderRadius: 10,
    width: "50%",
  },
  accordionSummary: {
    padding: 0,
    flexDirection: "row-reverse",
    height: "55px !important",
    minHeight: "55px !important",
    // [theme.breakpoints.down("xs")]: {
    //   height:'100px',
    // },
    "& .MuiIconButton-root": {
      padding: 0,
      background: "#EEEDEE",
      borderRadius: 3,
      marginRight: 15,
    },
    "& .MuiSwitch-root": {
      marginLeft: 20,
      "& .MuiIconButton-root": {
        background: "unset !important",
        marginRight: "0 !important",
        padding: "9px !important",
        borderRadius: "unset !important",
      },
    },
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
    },
  },
  accordionDetails: {
    padding: "15px 40px 16px",
    display: "block",
    [theme.breakpoints.down("xs")]: {
      padding: "0 8px 16px",
    },
    "& p": {
      margin: 0,
    },
  },
  qusList: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& li": {
      display: "flex",
      marginBottom: 8,
      color: "inherit",
      fontSize: 13,
      fontWeight: 500,
      "& svg": {
        marginRight: 8,
      },
    },
  },
  checkIcon: {
    color: "#33AF77",
  },
  crossIcon: {
    color: "#C2BDBD",
  },
}));
export default useStyles;
